import {SchemaProps} from "./JsonLdSchemaRouter";
import {
    areaServed,
    context,
    email,
    founder,
    foundingDate,
    logo,
    phone,
    pictureUri,
    rootAddress,
    rootDescription,
    rootName,
    rootOrgaId,
    rootUrl,
    sameAs,
    type_ngo
} from "./JsonLdUtil";

export function getHomePageSchema(props: SchemaProps) {
    return {
        "@context": context,
        "@type": type_ngo,
        "@id": rootOrgaId,
        "name": rootName,
        "url": rootUrl,
        "logo": logo,
        "description": rootDescription,
        "image": pictureUri(props),
        "foundingDate": foundingDate,
        "founder": founder,
        "address": rootAddress,
        "telephone": phone(props),
        "email": email(props),
        "areaServed": areaServed,
        "sameAs": sameAs
    };
}
